import { render, staticRenderFns } from "./cabinet-accounting-statistics.vue?vue&type=template&id=eff8e7da&scoped=true&"
import script from "./cabinet-accounting-statistics.vue?vue&type=script&lang=js&"
export * from "./cabinet-accounting-statistics.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-accounting-statistics.vue?vue&type=style&index=0&id=eff8e7da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff8e7da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eff8e7da')) {
      api.createRecord('eff8e7da', component.options)
    } else {
      api.reload('eff8e7da', component.options)
    }
    module.hot.accept("./cabinet-accounting-statistics.vue?vue&type=template&id=eff8e7da&scoped=true&", function () {
      api.rerender('eff8e7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/accounting/cabinet-accounting-statistics.vue"
export default component.exports